import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import EventCalendar from "../../Pages/User/EventCalender";
import AddClient from "../../Pages/User/AddClient";
import ClientList from "../../Pages/User/ClientList";
import Event from "../../Pages/User/Event";
import Overview from "../../Pages/User/Overview";
import AddNewEvent from "../../Pages/User/AddNewEvent";
import EventDetail from "../../Pages/User/EventDetail";
import ClientDetail from "../../Pages/User/ClientDetail";

const UserRoutes = () => {
  return (
    <Routes>
      <Route path="/overview" element={<Overview />} />
      <Route path="/event-calendar" element={<EventCalendar />} />
      <Route path="/add-client" element={<AddClient />} />
      <Route path="/client-list" element={<ClientList />} />
      <Route path="/view-client-detail" element={<ClientDetail />} />
      <Route path="/event" element={<Event />} />
      <Route path="/add-new-event" element={<AddNewEvent />} />
      <Route path="/view-event-detail" element={<EventDetail />} />

      <Route path="*" element={<Navigate to="/overview" />} />
    </Routes>
  );
};

export default UserRoutes;
